import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { SlickOnboard } from '../../service/slick-onboard/slick-onboard.service';
import { CreateBriefService } from '../../../briefs/service/create-brief/create-brief.service';
import { CollaboratorService } from '../../../../services/collaborator/collaborator.service';
import { DecimalPipe } from '@angular/common';
import { CreatorResponseDto } from '../../../../common/general-types/creators.dto';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'v2-congrats',
  imports: [DecimalPipe],
  templateUrl: './congrats.html',
  styleUrl: './congrats.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CongratsComponent implements OnInit {
  /** Fireworks overlay removes from DOM after this duration (matches CSS burst cadence). */
  private static readonly FIREWORKS_DURATION_MS = 2000;

  readonly fireworksVisible = signal(true);

  private readonly destroyRef = inject(DestroyRef);

  /** Services */
  public slickOnboardService = inject(SlickOnboard);
  public createBriefService = inject(CreateBriefService);
  public collaboratorService = inject(CollaboratorService);
  private currentUserService = inject(CurrentUserService);
  private router = inject(Router);
  /** Services - END */

  ngOnInit(): void {
    const fireworksTimerId = window.setTimeout(() => {
      this.fireworksVisible.set(false);
    }, CongratsComponent.FIREWORKS_DURATION_MS);
    this.destroyRef.onDestroy(() => window.clearTimeout(fireworksTimerId));

    console.log('CongratsComponent ngOnInit');
    console.log('newlyCreatedBrief: ', this.slickOnboardService.newlyCreatedBrief());
    console.log('selectedCreators: ', this.collaboratorService.selectedCreators());
  }

  getChannelLogo() {
    if (this.createBriefService.selectedUgcOnly()) {
      return '../../../../../assets/social-icon/ugc-videos.svg';
    } else {
      return this.createBriefService.selectedPrimaryChannel()?.channelIcon;
    }
  }

  getPotentialReach() {
    if (this.collaboratorService.selectedCreators() && this.collaboratorService.selectedCreators()!.length > 0) {
      return this.collaboratorService.selectedCreators().reduce((acc: number, creator: CreatorResponseDto) => acc + creator.instaFollowers + creator.tikTokFollowers + creator.youtubeSubscribers, 0);
    } else {
      return 0;
    }
  }

  getAverageEngagement() {
    if (this.collaboratorService.selectedCreators() && this.collaboratorService.selectedCreators()!.length > 0) {
      return this.collaboratorService.selectedCreators().reduce((acc: number, creator: CreatorResponseDto) => acc + this.getAvgEngaegement(creator), 0) / this.collaboratorService.selectedCreators().length;
    } else {
      return 0;
    }
  }

  getAvgEngaegement(creator: CreatorResponseDto) {
    if (creator && creator.ssCreator) {
      if (creator.ssCreator.instagramAverages && creator.ssCreator.tiktokAverages) {
        return ((creator.ssCreator.instagramAverages?.averageEngagementRate || 0) + (creator.ssCreator.tiktokAverages?.averageEngagementRate || 0)) / 2
      } else if (creator.ssCreator.instagramAverages) {
        return (creator.ssCreator.instagramAverages?.averageEngagementRate || 0)
      } else if (creator.ssCreator.tiktokAverages) {
        return (creator.ssCreator.tiktokAverages?.averageEngagementRate || 0)
      } else {
        return 0
      }
    } else {
      return 0
    }
  }

  continueToDashboard() {
    console.log('continueToDashboard');

    this.collaboratorService.selectedCreators.set([]);

    this.currentUserService.onboardingComplete.set(true);
    this.currentUserService.checkBrandComplete();

    this.router.navigate(['/dashboard']);
  }
}
